'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNull = isNull;
exports.removeSpace = removeSpace;
exports.matchTelFormat = matchTelFormat;
exports.matchEmailFormat = matchEmailFormat;
// 空白チェック
function isNull(val) {
    return this.removeSpace(val) == '';
}
// 空白文字の削除
function removeSpace(val) {
    return val ? val.replace(/\s+/g, '') : '';
}
// 電話番号のフォーマットチェック
function matchTelFormat(val) {
    return val.match(/[0-9]{2,4}[\-]{0,1}[0-9]{2,4}[\-]{0,1}[0-9]{2,4}/);
}
// メールのフォーマットチェック
function matchEmailFormat(val) {
    return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
}
